<ng-container>
  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        print
      </button> -->

      <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        (click)="printPage()">
        Print
      </button>


      <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
        (click)="exportExcel('Prantwise_All_Total_Business_Report')" mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>
  <div>
    <div class="container" id="print-section">
      <table class="table table-bordered" style="table-layout: auto; width: 100%;">
        <thead>

     <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 5" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - जिल्हा प्रतिनिधीनिहाय सद्यस्थिती 
               <span *ngIf="appliedFilters">
                    <small>
                      
                         <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 

                    </small>
                </span>
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

        
          <tr>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">जिल्हा</th>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">तालुका</th>
            <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;  word-wrap: break-word;">प्रतिनिधींचे नाव</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">निव्वळ एकूण</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">योजना एकूण</th>
            <th colspan="4" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" colspan="4" style="border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; border-left: 2px solid black;">{{ data.name }}</th>
              <!-- <th *ngIf="data.isVisible" rowspan="2">रक्कम रुपये</th> -->
            </ng-container>


<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">देणगी</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">कृषी विवेक </th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अशोकजी सिंघल विशेषांक नोंदणी</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">शिवाजी विशेषांक नोंदणी</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">नियमित अंक विक्री</th>
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">पुस्तक</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">राष्ट्रोत्थान निव्वळ ग्रंथ 2100/-</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">राष्ट्रोत्थान निव्वळ ग्रंथ 2500/-</th>
<th colspan="2" style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">विश्वसंचार संघाचा 2500</th>
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">पेंडींग व्यवसाय </th>
<th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

          </tr>

          <tr>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>

            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>

            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">वर्गणीदार संख्या</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
          
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नवीन</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
              <!-- <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->

            </ng-container>

<!-- <th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th> -->
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">वर्गणीदार</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति </th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण रु.</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति </th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">एकूण रु.</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">प्रति</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>
<th style="border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;"></th>

          </tr>
        </thead>
        <tbody>
     

<ng-container *ngFor="let item of finalData">
  <!-- Grand Total Row -->
  <ng-container *ngIf="item?.name === 'एकूण'; else officeRepBlock">
    <tr class="smallHeading">
      <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.name }}</td>

    <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item['net_नवीन'] }}</td>
    <td style="text-align: right; border-bottom: 2px solid black;">{{ (item['net_नूतनीकरण'] || 0) + (item['net_नूतनीकरणबाकी'] || 0)}}</td>
    <td style="text-align: right; border-bottom: 2px solid black;">{{ item['net_एकूण'] }}</td>
    <td style="text-align: right; border-bottom: 2px solid black;">{{ item['net_amount'] }}</td>

    <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item['yojana_नवीन'] }}</td>
    <td style="text-align: right; border-bottom: 2px solid black;">{{ (item['yojana_नूतनीकरण'] || 0) + (item['yojana_नूतनीकरणबाकी'] || 0)}}</td>
    <td style="text-align: right; border-bottom: 2px solid black;">{{ item['yojana_एकूण'] }}</td>
    <td style="text-align: right; border-bottom: 2px solid black;">{{ item['yojana_amount'] }}</td>

      <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item.sub }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['एकूण'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black;">{{ item['नवीन'] }}</td>
      <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ (item['नूतनीकरण'] || 0) + (item['नूतनीकरणबाकी'] || 0) }}</td>
      <!-- <td style="text-align: right; border-right: 2px solid black; border-bottom: 2px solid black;">{{ item['नूतनीकरणबाकी'] }}</td> -->

      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black;">{{ item[getKey(sub.name) + '_नवीन'] }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ (item[getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}</td>
          <td style="text-align: right; border-bottom: 2px solid black;">{{ (item[getKey(sub.name) + '_नवीन'] || 0) + (item[getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}</td>
          <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[getKey(sub.name) + '_एकूण'] }}</td>
          <!-- <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td> -->
        </ng-container>
      </ng-container>

       <!-- <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item['ठेवीदार'] }}</td> -->
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item['देणगी_amount'] }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item['pending_amount'] || 0 }}</td>
       <td style="text-align: right; border-bottom: 2px solid black; border-right: 2px solid black;">{{ getRowTotal(item) }}</td>
       

    </tr>
  </ng-container>

  <!-- Office Rep + District Grouping Block -->
  <ng-template #officeRepBlock>
    <!-- Office Rep Header -->
    <tr>
      <td colspan="3" class="text-center fw-bold" style="border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; font-weight: bold;">
        {{ item[0]?.prant_name }}
      </td>
      <td colspan="4" style="border-right: 2px solid black;"></td>
      <td colspan="4" style="border-right: 2px solid black;"></td>
      <td colspan="4" style="border-right: 2px solid black;"></td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td colspan="4" style="border-right: 2px solid black;"></td>
        </ng-container>
      </ng-container>

      <!-- <td style="border-right: 2px solid black;"></td> -->
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 1px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>
      <td style="border-right: 2px solid black;"></td>


    </tr>

    <!-- Group by District -->
    <ng-container *ngFor="let district of getDistrictGroups(item); let i = index">
      <!-- Taluka Rows -->
      <ng-container *ngFor="let row of district.rows">
        <tr>
          <td style="border-left: 2px solid black;">
            <strong *ngIf="district.rows[0] === row">{{ i + 1 }} . {{ row['rep_district'] }}</strong>
          </td>
          <td>{{ row['rep_taluka'] || '-' }}</td>
          <td>{{ row['rep_name'] ? row['rep_name'] : '-' }}{{ row['rep_taluka'] ? ' - ' + row['rep_taluka'] : '' }}</td>

          <td style="text-align: right; border-left: 2px solid black;">{{ row['net_नवीन'] }}</td>
          <td style="text-align: right;">{{ (row['net_नूतनीकरण'] || 0) + (row['net_नूतनीकरणबाकी'] || 0) }}</td>
          <td style="text-align: right;">{{ row['net_एकूण'] }}</td>
          <td style="text-align: right;">{{ row['net_amount'] }}</td>

          <td style="text-align: right; border-left: 2px solid black;">{{ row['yojana_नवीन'] }}</td>
          <td style="text-align: right;">{{ (row['yojana_नूतनीकरण'] || 0) + (row['yojana_नूतनीकरणबाकी'] || 0)}}</td>
          <td style="text-align: right;">{{ row['yojana_एकूण'] }}</td>
          <td style="text-align: right;">{{ row['yojana_amount'] }}</td>

          <td style="text-align: right; border-left: 2px solid black;">{{ row['sub'] }}</td>
          <td style="text-align: right;">{{ row['एकूण'] }}</td>
          <td style="text-align: right;">{{ row['नवीन'] }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ (row['नूतनीकरण'] || 0) + (row['नूतनीकरणबाकी'] || 0) }}</td>
          <!-- <td style="text-align: right; border-right: 2px solid black;">{{ row['नूतनीकरणबाकी'] }}</td> -->

          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td style="text-align: right; border-left: 2px solid black;">{{ row[getKey(sub.name) + '_नवीन'] }}</td>
              <td style="text-align: right;">{{ (row[getKey(sub.name) + '_नूतनीकरण'] || 0) +  (row[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}</td>
              <td style="text-align: right;">{{ (row[getKey(sub.name) + '_नवीन'] || 0) + (row[getKey(sub.name) + '_नूतनीकरण'] || 0) + (row[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}</td>
              <td style="text-align: right; border-right: 2px solid black;">{{ row[getKey(sub.name) + '_एकूण'] || 0 }}</td>
              <!-- <td style="text-align: right; border-right: 2px solid black;">{{ row[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td> -->
            </ng-container>
          </ng-container>
 
          <!-- <td style="text-align: right; border-right: 2px solid black;">{{ row['ठेवीदार'] }}</td> -->
          <td style="text-align: right; border-right: 2px solid black;">{{ row['देणगी_amount'] }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-left: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; ">{{ 0 }}</td>
          <td style="text-align: right; border-left: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; ">{{ 0 }}</td>
          <td style="text-align: right; border-left: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ 0 }}</td>
          <td style="text-align: right; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right;">{{ row['pending_amount'] || 0 }}</td>
          <!-- <td style="text-align: right; border-left: 2px solid black;">{{ 0 }}</td> -->
          <td style="text-align: right; border-left: 2px solid black; border-right: 2px solid black;">{{ getRowTotal(row) }}</td>


        </tr>
      </ng-container>

      <!-- District Subtotal Row -->
      <tr class="smallHeading">
        <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; text-align: right;">
          {{ district.total['rep_district'] }} - एकूण
        </td>
         <!-- जिल्हा निव्वळ एकूण -->
        <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['net_नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (district.total['net_नूतनीकरण'] || 0) + (district.total['net_नूतनीकरणबाकी'] || 0) }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['net_एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['net_amount'] }}</td>

        <!-- जिल्हा योजना एकूण  -->
        <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['yojana_नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (district.total['yojana_नूतनीकरण'] || 0) + (district.total['yojana_नूतनीकरणबाकी'] || 0)}}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['yojana_एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['yojana_amount'] }}</td>

        <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total.sub }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total['नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ (district.total['नूतनीकरण'] || 0) + (district.total['नूतनीकरणबाकी'] || 0) }}</td>
        <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total['नूतनीकरणबाकी'] }}</td> -->

        <ng-container *ngFor="let sub of subTypesName">
          <ng-container *ngIf="sub.isVisible">
            <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ district.total[getKey(sub.name) + '_नवीन'] }}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (district.total[getKey(sub.name) + '_नूतनीकरण'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (district.total[getKey(sub.name) + '_नवीन'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरण'] || 0) + (district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}</td>
            <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total[getKey(sub.name) + '_एकूण'] }}</td>
            <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td> -->
          </ng-container>
        </ng-container>

          <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total['ठेवीदार']  }}</td> -->
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total['देणगी_amount'] }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; -left: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ district.total['pending_amount'] || 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black; border-right: 2px solid black;">{{ getRowTotal(district.total) }}</td>


      </tr>
    </ng-container>

    <!-- Office Representative Total Row -->
    <tr class="smallHeading" *ngIf="item[item.length - 1]?.isOfficeRepTotal">
      <td colspan="3" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; text-align: center;">
        {{ item[item.length - 1]['name'] }}
      </td>

       <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['net_नवीन'] }}</td>
       <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (item[item.length - 1]['net_नूतनीकरण'] || 0) + (item[item.length - 1]['net_नूतनीकरणबाकी'] || 0)}}</td>
       <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['net_एकूण'] }}</td>
       <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['net_amount']  }}</td>

       <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['yojana_नवीन'] }}</td>
       <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (item[item.length - 1]['yojana_नूतनीकरण'] || 0) +  (item[item.length - 1]['yojana_नूतनीकरणबाकी'] || 0)}}</td>
       <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['yojana_एकूण'] }}</td>
       <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['yojana_amount'] }}</td>

      <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['sub'] }}</td>
      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['एकूण'] }}</td>
      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['नवीन'] }}</td>
      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ (item[item.length - 1]['नूतनीकरण'] || 0) + (item[item.length - 1]['नूतनीकरणबाकी'] || 0) }}</td>
      <!-- <td style="text-align: right; border-top: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length - 1]['नूतनीकरणबाकी'] }}</td> -->

      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
            {{ item[item.length - 1][getKey(sub.name) + '_नवीन'] }}
          </td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
            {{ (item[item.length - 1][getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[item.length - 1][getKey(sub.name) + '_नूतनीकरणबाकी'] || 0)}}
          </td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
            {{ (item[item.length - 1][getKey(sub.name) + '_नवीन'] || 0) + (item[item.length - 1][getKey(sub.name) + '_नूतनीकरण'] || 0) + (item[item.length - 1][getKey(sub.name) + '_नूतनीकरणबाकी'] || 0) }}
          </td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
            {{ item[item.length - 1][getKey(sub.name) + '_एकूण'] }}
          </td>
          <!-- <td style="text-align: right; border-top: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
            {{ item[item.length - 1][getKey(sub.name) + '_नूतनीकरणबाकी'] }}
          </td> -->
        </ng-container>
      </ng-container>

          <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[item.length-1]['ठेवीदार'] }}</td> -->
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ item[item.length-1]['देणगी_amount'] }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ 0 }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item[item.length-1]['pending_amount'] || 0  }}</td>
          <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black; border-right: 2px solid black;">{{  getRowTotal(item[item.length - 1]) }}</td>


    </tr>
  </ng-template>
</ng-container>





       
       
        </tbody>
      </table>
    </div>
  </div>

</ng-container>
<!-- <div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div> -->